import { db } from '../firebase';
import { getBackendError } from 'common/utils';

const subcategoryMapper = (documentSnapshot) => {
  const { name, lead, categoryUid, image, isFree } = documentSnapshot.data();

  return {
    alias: documentSnapshot.id,
    name,
    lead,
    categoryUid,
    image,
    isFree,
  };
};

const subcategoryListMapper = (docs) => {
  return docs.map((documentSnapshot) => subcategoryMapper(documentSnapshot));
};

export const getSubcategoriesList = async () => {
  return new Promise((resolve, reject) => {
    db
      .collection('subcategory')
      .orderBy('categoryUid')
      .get()
      .then((querySnapshot) => resolve(subcategoryListMapper(querySnapshot.docs)))
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const updateSubcategory = async (
  id,
  isFree,
  categoryUid,
  nameEn,
  nameRu,
  nameUk,
  namePl,
  nameIt,
  nameEs,
  namePt,
  leadEn,
  leadRu,
  leadUk,
  leadPl,
  leadIt,
  leadEs,
  leadPt,
  image,
  ) => {
  return new Promise((resolve, reject) => {
    //delete item
    db
      .collection('subcategory')
      .doc(id)
      .delete()
      .then(() => {
        //insert item
        db
        .collection('subcategory')
        .doc(id)
        .set({
          isFree,
          categoryUid,
          name: {
            en: nameEn,
            ru: nameRu,
            uk: nameUk,
            it: nameIt,
            pl: namePl,
            es: nameEs ? nameEs : '',
            pt: namePt ? namePt : '',
          },
          lead: {
            en: leadEn,
            ru: leadRu,
            uk: leadUk,
            it: leadIt,
            pl: leadPl,
            es: leadEs ? leadEs : '',
            pt: leadPt ? leadPt : '',
          },
          image
        })
        .then(() => resolve())
        .catch((error) => {
          reject(getBackendError(error));
        });
      })
      .catch((error) => {
        console.log(error);
        alert('Delete ' + id);
        reject(getBackendError(error));
      });
  });
};

export const updateSubcategoryImage = (id, image) => {
  return new Promise((resolve, reject) => {
    db
      .collection('subcategory')
      .doc(id)
      .update({
        image
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};

export const createSuccategory = (
  id,
  isFree,
  categoryUid,
  nameEn,
  nameRu,
  nameUk,
  namePl,
  nameIt,
  nameEs,
  namePt,
  leadEn,
  leadRu,
  leadUk,
  leadPl,
  leadIt,
  leadEs,
  leadPt,
) => {
  return new Promise((resolve, reject) => {
    db
      .collection('subcategory')
      .doc(id)
      .set({
        isFree,
        categoryUid,
        name: {
          en: nameEn,
          ru: nameRu,
          uk: nameUk,
          it: nameIt,
          pl: namePl,
          es: nameEs,
          pt: namePt,
        },
        lead: {
          en: leadEn,
          ru: leadRu,
          uk: leadUk,
          it: leadIt,
          pl: leadPl,
          es: leadEs,
          pt: leadPt,
        },
        image: ''
      })
      .then(() => resolve())
      .catch((error) => {
        reject(getBackendError(error));
      });
  });
};
